// @flow
import Rencontre from 'components/rencontre/Rencontre';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/rencontre/Rencontre';
import { postUserPref } from 'actions/userActions';
import { displayModal } from 'actions/modalActions';
import { fetchPageList } from 'actions/pageActions';
import { fetchRencontre } from 'actions/rencontreActions';

export default connect(
  (state: StateType): StateProps => ({
    id_rencontre: state.rencontreState.rencontre.id,
    title: state.pageListState.title,
    description: state.pageListState.description,
    featured_media: state.pageListState.featured_media,
    rencontre_background: state.pageListState.rencontre_background,
    meta_title: state.rencontreState.rencontre.meta_title,
    meta_description: state.rencontreState.rencontre.meta_description,
    sidebar_content: state.pageListState.sidebar_content,
    rencontreData: state.rencontreState.rencontre,
    rencontreFetchStatus: state.rencontreState.status,
    status: state.pageListState.status,
    alertesBilletterie: state.userState.userPref.alertes_billetterie,
    identifie: state.userState.userPref.identifie,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    fetchRencontre: (slug: string) => dispatch(fetchRencontre(slug)),
    postUserPref: (action: string, value: any, token: string) => dispatch(postUserPref(action, value, token)),
    displayModal: (modalObject: string, content?: Object) => dispatch(displayModal(modalObject, content))
  })
)(Rencontre);
